import { createDataMapper } from '@common/utils/query/dataMappers';
import { BackendAccount, Account } from '../types';

const mapBackendAccountToFrontendAccount = (
    backendAccount: BackendAccount,
): Account => {
    return {
        id: backendAccount.id,
        name: backendAccount.humanName,
        status: backendAccount.subscriptionStatus,
        rights: backendAccount.rights,
    };
};

export const transformAccount = createDataMapper<BackendAccount, Account>(
    mapBackendAccountToFrontendAccount,
    true,
);
